// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1apFo","label":"Section_label__3WvBa","contentWrap":"Section_contentWrap__gQGZ_","footer":"Section_footer__13Fwv","footerInner":"Section_footerInner__HQfV2"};